<template lang="html">
  <div class="customizer-external-includes-china-headers">
    <div
      :class="[
        'header-container',
        { 'expanded': showHeaderContainer },
        { 'show-dropdown': showCountryDropdown }
      ]">
      <div class="main-header-container vans-china">
        <div class ="brand">
          <a :href="baseUrl">
            <div class="brand-logo"></div>
          </a>
        </div>
        <div class="upper-right-area">
          <ul class="upper-right-bar">
            <li @click="clickCountryBar(true)" class="country-bar">
              <a href="javascript:;" class="country-drop-trigger">
                <svg width="10px" viewBox="0 0 460 512">
                  <path fill="#D0D0D0" d="M5 185.466l67.589-67.615 157.423 157.399 157.399-157.399 67.589 67.615-224.988 224.988z"></path>
                </svg>
                <span>位置</span>
              </a>
              <ul
                @focusout="focusoutCountryDropdown"
                ref="headerDropdown"
                tabindex="-1"
                :class="[ 'country-dropdown', { 'expanded': showCountryDropdown } ]"
              >
                <li>
                  <a href="http://vans.com.cn/"><span>中国</span></a>
                </li>
                <li>
                  <a href="http://www.vans.com.hk/en/"><span>Hong Kong SAR</span></a>
                </li>
                <li>
                  <a href="http://www.vans.com.hk/"><span>香港特別行政區</span></a>
                </li>
                <li>
                  <a href="http://www.vans.co.kr/"><span>대한민국</span></a>
                </li>
                <li>
                  <a href="http://www.vans.com.sg/"><span>Singapore</span></a>
                 </li>
                <li>
                  <a href="http://www.vans.co.in/"><span>India</span></a>
                 </li>
                <li>
                  <a href="http://www.vans.com.my/"><span>Malaysia</span></a>
                 </li>
                <li>
                  <a href="http://www.vans.com/shop.html"><span>USA</span></a>
                 </li>
                <li>
                  <a href="http://www.vans.ca/en_ca/homepage.html"><span>Canada (English)</span></a>
                 </li>
                <li>
                  <a href="http://www.vans.ca/fr_ca/homepage.html">
                    <span>Canada (Français) </span>
                  </a>
                </li>
                <li>
                  <a href="http://www.vans.mx/es_mx/homepage.html">
                    <span>Méjico (Español) </span>
                  </a>
                </li>
                <li>
                  <a href="http://vansdobrasil.com/">
                    <span>Brasil </span>
                  </a>
                </li>
                <li>
                  <a href="http://www.vansargentina.com/">
                    <span>Argentina </span>
                  </a>
                </li>
                <li>
                  <a href="http://www.vans.at/">
                    <span>Österreich </span>
                  </a>
                </li>
                <li>
                  <a href="http://www.vans.fr/">
                    <span>France </span>
                  </a>
                </li>
                <li>
                  <a href="http://www.vans.de/">
                    <span>Deutschland </span>
                  </a>
                </li>
                <li>
                  <a href="http://www.vans.ie/">
                    <span>Ireland </span>
                  </a>
                </li>
                <li>
                  <a href="http://www.vans.eu/">
                    <span>Israel </span>
                  </a>
                </li>
                <li>
                  <a href="http://www.vans.it/">
                    <span>Italia </span>
                  </a>
                </li>
                <li>
                  <a href="http://www.vans.nl/">
                    <span>Nederland </span>
                  </a>
                </li>
                <li>
                  <a href="http://www.vans.eu/">
                    <span>Polska </span>
                  </a>
                </li>
                <li>
                  <a href="http://www.vans.pt/">
                    <span>Portugal </span>
                  </a>
                </li>
                <li>
                  <a href="http://vans.ru/">
                    <span>Россия </span>
                  </a>
                </li>
                <li>
                  <a href="http://www.vans.es/">
                    <span>España </span>
                  </a>
                </li>
                <li>
                  <a href="http://www.vans.se/">
                    <span>Sweden </span>
                  </a>
                </li>
                <li>
                  <a href="http://www.vans.eu/">
                    <span>Switzerland </span>
                  </a>
                </li>
                <li>
                  <a href="http://www.vans.eu/">
                    <span>Türkiye </span>
                  </a>
                </li>
                <li>
                  <a href="http://www.vans.co.uk/">
                    <span>United Kingdom </span>
                  </a>
                </li>
                <li>
                  <a href="http://www.vansjapan.com/">
                    <span>日本 </span>
                  </a>
                </li>
                <!-- <li>
                  <a href="http://www.vanstaiwan.com/">
                    <span>台灣 </span>
                  </a>
                </li>-->
                <li>
                  <a href="http://www.vans.net.au/">
                    <span>Australia </span>
                  </a>
                </li>
                <li>
                  <a href="http://www.vans.co.nz/">
                    <span>New Zealand </span>
                  </a>
                </li>
              </ul>
            </li>
            <li class="contact-bar desktop-only">
              <a :href="`${ baseUrl }/article-gongsi-1471.html`"><span>获取帮助</span></a>
            </li>
            <li class="artwork-bar desktop-only">
              <a :href="`${ baseUrl }/passport.html`">
                <svg width="25" viewBox="0 0 512 512">
                  <path d="M251.089 474.366l-7.962-11.469c-32.793-47.483-72.599-82.455-107.666-113.258-59.141-51.938-110.131-96.767-110.131-180.171 0-32.983 12.7-63.975 35.826-87.195 23.221-23.41 54.212-36.3 87.384-36.3 23.884 0 46.915 6.824 66.628 19.714 14.311 9.383 26.443 21.609 35.731 35.826 22.462-34.215 61.32-55.539 103.307-55.539 67.955 0 123.21 55.444 123.21 123.494 0 36.489-10.71 68.144-33.74 99.611-20.093 27.58-47.388 51.748-76.296 77.433-37.627 33.457-76.579 67.955-108.614 116.102l-7.677 11.752zM148.066 95.827c-28.054 0-38.196 6.824-57.814 24.168-19.524 17.249-18.861 69.188-8.531 91.46 26.537 57.341 20.946 45.587 74.4 93.355 33.172 25.59 62.837 61.984 95.251 100.464 31.939-39.142 66.628-73.262 98.568-99.99 28.243-30.707 36.963-38.954 55.918-61.605 20.472-24.643 25.116-48.525 23.221-76.769-3.128-47.483-20.283-68.524-73.736-72.504-40.565-3.033-50.895 18.008-75.537 39.806l-28.433 35.067-25.116-29.381c-15.543-18.103-13.553-18.103-29.855-27.486-16.586-12.795-28.149-16.586-48.337-16.586z"></path>
                </svg>
                <span>我的作品</span>
              </a>
            </li>
            <li class="location-bar">
              <a :href="`${ baseUrl }/exshop-search.html`">
                <svg width="25" viewBox="0 0 792 1024">
                  <path d="M736.97 366.932c0-201.956-153.6-366.932-341.334-366.932s-341.334 164.978-341.334 366.932v2.844c0 295.822 301.512 634.31 301.512 634.31 11.378 11.378 25.6 19.912 39.822 19.912v0c14.222 0 28.444-5.688 39.822-19.912 2.844-5.688 301.512-347.022 301.512-634.312v0-2.844zM395.636 512c-93.868 0-170.668-76.8-170.668-170.668s76.8-170.668 170.668-170.668 170.666 76.8 170.666 170.668-76.8 170.668-170.668 170.668z"></path>
                </svg>
                <span>STORE</span>
              </a>
            </li>
            <li class="cart-bar">
              <a :href="`${ baseUrl }/cart.html`">
                <svg  width="30px" viewBox="0 0 1114 1024">
                  <path d="M20.732 46.289h222.66l84.675 247.749h765.208l-112.901 470.415h-589.586l-228.937-624.082-141.126 3.135v-97.217zM459.784 667.236h445.325l59.586-275.974h-598.993l94.082 275.974zM453.513 802.091c-50.179 0-87.811 37.632-87.811 87.811 0 47.044 40.767 87.811 87.811 87.811s87.811-37.632 87.811-87.811c3.135-50.179-37.632-87.811-87.811-87.811zM864.343 802.091c-50.179 0-87.811 37.632-87.811 87.811 0 47.044 40.767 87.811 87.811 87.811 50.179 0 87.811-37.632 87.811-87.811s-37.632-87.811-87.811-87.811z"></path>
                </svg>
                <span>我的购物车</span>
              </a>
            </li>
            <li class="account-bar">
              <a :href="`${ baseUrl }/passport-signup.html`" class="desktop-only"><span> / 注册</span></a>
              <a :href="`${ baseUrl }/passport-login.html`">
                <svg width="30" viewBox="0 0 458 512">
                  <path d="M10.947 495.832c0-45.81 0-86.231 0-133.389 55.242-25.6 110.484-51.2 168.421-78.147-14.821-43.116-32.337-80.842-41.769-121.263-10.779-47.158-12.126-99.706 40.421-122.611 28.294-12.127 71.411-12.127 99.706 1.347 49.853 24.252 49.853 76.8 37.726 123.958-9.432 39.073-26.947 74.106-43.116 117.221 56.589 26.947 114.526 53.894 171.116 79.495 0 47.158 0 87.579 0 132.042-145.516 1.348-288.337 1.348-432.505 1.348z"></path>
                </svg>
                <span> 登录 </span>
              </a>
            </li>
            <li @click="clickMenuBar()" class="menu-bar">
              <a href="javascript:;">
                <svg  width="30" viewBox="0 0 512 512">
                  <path d="M32 96h448v96h-448zM32 224h448v96h-448zM32 352h448v96h-448z"></path>
                </svg>
              </a>
            </li>
          </ul>
        </div>
        <div :class="[ 'nav-bar', { 'expanded': showNavBar } ]">
          <ul class= "nav-list">
            <li class="mobile-only"><a href="http://chat8.live800.com/live800/chatClient/chatbox.jsp?companyID=772724&configID=150737&jid=9415958668"><b>LIVE CHAT</b></a></li>
            <li><a :href="`${ baseUrl }/article-vans-l-30.html`">关于 <b>VANS</b></a></li>
            <li><a :href="`${ baseUrl }/article-artist-sl-23-local.html`">运动员</a></li>
            <li><a href="https://houseofvansasia.com.cn/musicianswanted/zh-cn"><b>HOUSE OF VANS</b></a></li>
            <li><a :href="`${ baseUrl }/customs.html`"><b>CUSTOMS</b></a></li>
            <li><a :href="`${ baseUrl }/gallery-index---0---11.html`">新品上线</a></li>
            <li><a :href="`${ baseUrl }/gallery-index---0---36.html`">男子</a></li>
            <li><a :href="`${ baseUrl }/gallery-index---0---37.html`">女子</a></li>
            <li><a :href="`${ baseUrl }/exshop-search.html`">搜索店铺</a></li>
          </ul>
        </div>
        <div @click="clickHideHeader()" :class="[ 'hide-header', { 'expanded': showHideHeader } ]">
          <div class="hide-indicator">
            <svg width="15px" viewBox="0 0 460 512">
              <path fill="#fff" d="M229.978 381.202l225.449-250.266h-450.897l225.447 250.266z"></path>
            </svg>
          </div>
        </div>
      </div>
    </div>

    <div class="gtm-sidebar-livechat" style="position: absolute; top: 50%; right: 0; transform: translateY(-50%); z-index: 50;">
      <a target="_parent"
      href="http://chat8.live800.com/live800/chatClient/chatbox.jsp?companyID=772724&configID=150737&jid=9415958668">
        <button style="background: #AA292D; height: 35px; width: 35px; outline: none; border: none; cursor:pointer; padding:0;">
          <svg xmlns:xlink="http://www.w3.org/1999/xlink" width="35px" height="35px" viewBox="30.6 120.6 550.8 550.8">
             <g>
              <path fill="#FFFFFF" d="M405.144,254.016H206.856c-24.48,0-42.84,18.36-42.84,42.84v127.296c0,24.479,18.36,42.84,42.84,42.84
              v70.992l110.16-70.992h88.128c24.48,0,42.841-18.36,42.841-42.84V296.856C447.984,272.376,429.624,254.016,405.144,254.016z
               M419.832,424.152c0,8.567-6.12,14.688-14.688,14.688h-96.695l-73.44,46.512V438.84h-28.152c-8.568,0-14.688-6.12-14.688-14.688
              V296.856c0-8.568,6.12-14.688,14.688-14.688h198.288c8.568,0,14.688,6.12,14.688,14.688V424.152z"/>
            </g>
          </svg>
        </button>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'chinaHeaders',
  data() {
    return {
      showHeaderContainer: false,
      showHideHeader: false,
      showNavBar: false,
      showCountryDropdown: false
    };
  },
  computed: {
    baseUrl() {
      const { mainSiteUrls } = this.$store.state.endPoints.customizer;
      const { env } = this.$store.state.utils;
      let baseUrl = '';

      if (!!mainSiteUrls && mainSiteUrls[env]) {
        baseUrl = mainSiteUrls[env];
      }

      return baseUrl;
    }
  },
  methods: {
    clickHideHeader() {
      this.showHeaderContainer = !this.showHeaderContainer;
    },
    clickMenuBar() {
      this.showHideHeader = !this.showHideHeader;
      this.showNavBar = !this.showNavBar;
    },
    focusoutCountryDropdown(ev) {
      if (!this.$refs.headerDropdown.contains(ev.relatedTarget)) {
        this.clickCountryBar();
      }
    },
    clickCountryBar(state = false) {
      this.showCountryDropdown = state;

      if (state) {
        this.$nextTick(() => this.$refs.headerDropdown.focus());
      }
    },
    hideElements() {
      this.showHeaderContainer = false;
      this.showHideHeader = false;
      this.showNavBar = false;
      this.showCountryDropdown = false;
    },
    setDataLayer() {
      window.dataLayer = [ {
          "pageName": "customizer",
          "pageCategory": "customs",
          "platform": "customizer",
          "language": "zh",
          "country": "CN",
          "currency": "CNY",
          "currencySymbol": "￥"
      } ];
      this.$customsGTM.GTMScript("GTM-M2CRWRR7");
    }
  },
  created() {
    this.setDataLayer();
    this.$eventBus.$on('changeExternalHeadersVisibility', this.hideElements);
  },
  beforeDestroy() {
    this.$eventBus.$off('changeExternalHeadersVisibility', this.hideElements);
  }
}
</script>